<template lang="pug">
  include ./../../../mixins
  div
    +b.icon-header__open-menu.svg--fs_lg.--cursor_hand.I(
    :class="vision ? 'icon-closes': 'icon-menus'"
    @click.prevent='toggleMenu'
  )
    +b.drawer(
      :class="vision ? 'drawer--isactive': 'drawer--inactive'"
    )
      +e.overlay(
        :class="vision ? 'drawer__overlay--isactive': 'drawer__overlay--inactive'"
      )
      +e.sidebar(
        :class="vision ? 'drawer__sidebar--isactive' : 'drawer__sidebar--inactive'"
      )
        slot()
</template>

<script>
import { hiddenbody, unhiddenbody } from '../Forms/utils';

export default {

  name: 'HeaderMenuCommon',
  props: {
    collapsable: {
      default: () => false,
    },
    template: {
      default: () => false,
    },
  },
  data() {
    return {
      vision: false,
    }
  },

  methods: {
    toggleMenu() {
      this.vision = !this.vision
      if (this.vision) {
        hiddenbody()
      } else {
        unhiddenbody()
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/HeaderMenuCommon.vue